export default __webpack_public_path__ + "static/media/delete.9587d245.svg";